import React, { useEffect, useState } from "react";
import axios from "axios";

const RoomType = () => {
    const [rooms, setRooms] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_ROOMS;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setRooms(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, []);

    return (
        <select name="" id="">
            <option value="" disabled selected>Room Type</option>
            {rooms.length > 0 ? (
                rooms.map((room, index) => (
                    <option value={room.name} key={index}>
                        {room.name}
                    </option>
                ))
            ) : (
                <option disabled>Loading rooms...</option>
            )}
        </select>
    );
};

export default RoomType;